import { useEffect, useRef } from "react";
import { BroadcastChannel } from "broadcast-channel";
import { CustomObject } from "../types";

type Data = CustomObject | string | number | boolean;

type Callback = (data?: Data) => void;

const channels = new Map<string, Callback>();

const useBroadcastChannel = () => {
    const broadcast = useRef<BroadcastChannel<string>>();

    const fireMessage = (channel: string, data?: Data) => {
        const callback = channels.get(channel);

        callback && callback(data);
    };

    const registerChannel = (channel: string, callback: Callback) => {
        if (!channels.has(channel)) {
            channels.set(channel, callback);
        }
    };

    const sendToChannel = (channel: string, data?: Data) => {
        broadcast.current?.postMessage(
            JSON.stringify({
                channel,
                data,
            })
        );
    };

    useEffect(() => {
        broadcast.current = new BroadcastChannel("whatsapp-integration-ccs");

        broadcast.current.onmessage = (event) => {
            const { channel, data } = JSON.parse(event);

            fireMessage(channel, data);
        };
    }, []);

    return { registerChannel, sendToChannel };
};

export default useBroadcastChannel;
